<span (click)="onHandleClick()" class="icon"
  ><img src="/assets/images/cross.svg">
  </span
>
  <div class="gallery">
    <div *ngFor="let image of data.images;">
      <img src="{{ image.url }}" (click)="openDialog(image.url)"/>
    </div>
  </div>